import type { ReactNode } from 'react';
import { BellRing } from 'lucide-react';
import { Card } from '@/components/ui';
import { formatRelative } from '@/utils/format';
import type { OverviewSnapshot } from '@/types/api';

/** Open alerts, worst first: what the worker has found (and told, when Telegram is set). */
export function AlertsCard({ alerts }: { readonly alerts: OverviewSnapshot['alerts'] }): ReactNode {
  if (alerts.length === 0) return null;

  return (
    <Card title={`Открытые алерты: ${alerts.length}`} icon={BellRing} flush>
      <div className="table-scroll">
        <table>
          <tbody>
            {alerts.slice(0, 10).map((alert) => (
              <tr key={alert.key}>
                <td className="shrink">
                  <span className={alert.severity === 'critical' ? 'tone-down' : 'tone-degraded'} aria-hidden="true">
                    {alert.severity === 'critical' ? '■' : '▲'}
                  </span>
                </td>
                <td>{alert.detail}</td>
                <td className="shrink faint text-sm nowrap">{formatRelative(alert.openedAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
